import * as React from 'react'
import { Page, Form, Button, Card, Icon } from 'tabler-react'
import Cookies from 'js-cookie'
import toast from 'cogo-toast'

import Request from '../../shared/request'
import logo from '../../assets/brand_logo.svg'

import PageComponent from '../PageComponent'
import './login.scss'
import wechat from './social-wechat.svg'
import googleIcon from './social-google.svg'
import i18n from '../../shared/i18n'

class Login extends PageComponent {
  state = {
    isWechat: false,
    forward: '/dashboard',
    isProcessing: false,
    email: '',
    password: '',
    auto: false,
    wechatModal: false,
    qrcodeURL: '',
    qrcodeBase64: '',
    UUID: '',
    wechatMessage: '',
    tab: 'email',
    phone: '',
    areacode: '86',
  };

  componentDidMount() {
    const search = new URLSearchParams(window.location.search)
    const returnURL =
      search.get('forward') || search.get('return_to') || '/dashboard'
    const isWechat = /MicroMessenger/gi.test(window.navigator.userAgent)
    this.setState({
      forward: returnURL,
      isWechat,
    })
    window.addEventListener('google:granted', (e) => this.loginByGoogle(e.detail))
  }

  loginByGoogle = async (tokens) => {
    toast.info('Google 登陆中...')
    const accessToken = tokens.access_token
  
    if (accessToken) {
      const data = await Request.call('loginByOauth', {
        accessToken,
        type: 'google',
      })
      if (data && data.token) {
        this.saveToken(data)
        window.location.href = this.state.forward || '/dashboard'
      }
    }
  }

  componentWillMount() {
    const searchParams = new URLSearchParams(window.location.search)
    const login = searchParams.get('login')
    if (login) {
      const [email, password] = atob(login).split(':')
      this.setState({ email, password, auto: true })
    }
  }

  login = async e => {
    e.preventDefault()
    this.setState({ isProcessing: true })
    const { email, password, phone, areacode } = this.state
    let { forward } = this.state
    const body = { password }
    if (this.state.tab === 'email') {
      body.email = email
    } else {
      body.phone = `+${areacode}${phone}`
    }
    const userInfo = await Request.call('loginUser', body)
    if (userInfo) {
      this.saveToken(userInfo)
      if (forward && forward.indexOf('malus.zendesk.com') > -1) {
        forward = `https://getmalus.com/api/loginZendesk?token=${userInfo.token
          }`
      }
      window.location.href = forward || '/dashboard'
    }
    this.setState({ isProcessing: false })
  };

  autoLogin = async _ => {
    const { email, password, forward } = this.state
    const userInfo = await Request.call('loginUser', { email, password })
    if (userInfo) {
      this.saveToken(userInfo)
      window.location.href = forward || '/dashboard'
    }
    this.setState({ isProcessing: false })
  };

  saveToken = userInfo => {
    if (userInfo) {
      localStorage.setItem('login', JSON.stringify(userInfo))
      Cookies.set('malus-token', userInfo.token, {
        domain: `.${window.location.host
          .split('.')
          .slice(-2)
          .join('.')}`,
      })
    }
  };

  getUserInfo = async authorizationCode => {
    const data = await Request.call('loginByOauth', {
      type: 'wechat',
      authorizationCode,
    })
    if (data) {
      this.saveToken(data)
      this.setState({
        wechatMessage: `${data.displayName} 登陆成功，正在跳转...`,
      })
      setTimeout(() => {
        window.location.href = this.state.forward || '/dashboard'
      }, 2000)
    }
  };

  getCode = async (uuid, time) => {
    const { status, result } = await Request.call(`getWechatCode?uuid=${uuid}&_=${time}`)
    switch (status) {
      case 405:
        // 登陆成功
        this.setState({ wechatMessage: i18n.t('dash-login-processing') })
        this.getUserInfo(result.code)
        break
      case 404:
        this.setState({ wechatMessage: '手机已扫描' })
        // 继续poll
        setTimeout(() => {
          this.getCode(this.state.UUID, Date.now())
        }, 1000)
        // 扫描成功
        break
      case 403:
        this.setState({ wechatMessage: '', wechatModal: false })
        toast.warn('微信登陆已取消')
        // 取消本次登陆
        break
      case 402:
      case 500:
        this.getUUID()
        // 重新获取uuid
        break
      case 408:
        // 继续poll
        setTimeout(() => {
          this.getCode(uuid, Date.now())
        }, 1000)
        break
      default:
        break
    }
  };

  getUUID = async () => {
    this.setState({ wechatModal: true })
    // const data = await Request.call('getWechatLoginCode')
    // if (data) {
    //   this.setState({ qrcodeBase64: data.qrcodeURL, UUID: data.UUID })
    //   this.getCode(data.UUID, Date.now())
    // }
  };

  render() {
    const { auto, email, password } = this.state
    return (
      <Page className="malus-login">
        {auto ? (
          <Card className="form-card">
            <Card.Header>
              <Card.Title>{i18n.t('dash-login-title')}</Card.Title>
            </Card.Header>


            <Card.Body>
              <div>
                {i18n.t('dash-login-email')}：<strong>{email}</strong>
              </div>
              <div>
                {i18n.t('dash-login-password')}：<strong>{password}</strong>
              </div>
            </Card.Body>
            <Card.Footer className="warning-message">
              <p>
                <i className="fe fe-bell mr-2" />
                {i18n.t('dash-login-keeptip')}
              </p>

              <Button
                color="info"
                loading={this.state.isProcessing}
                pill
                onClick={this.autoLogin}>
                {i18n.t('dash-login-submit')}
              </Button>
            </Card.Footer>
          </Card>
        ) : (
          <Card className="form-card login">
            <Card.Header>
              <a className="brand" href="/">
                <img src={logo} alt="" />
              </a>
            </Card.Header>
            <Card.Body>
              <div className="sign-tab">
                <h3
                  onClick={() => this.setState({ tab: 'email' })}
                  className={this.state.tab === 'email' ? 'active' : ''}>
                  {i18n.t('dash-login-emailtab')}
                </h3>
                <h3
                  onClick={() => this.setState({ tab: 'phone' })}
                  className={this.state.tab === 'phone' ? 'active' : ''}>
                  {i18n.t('dash-login-phonetab')}
                </h3>
              </div>
              {this.state.tab === 'phone' ? (
                <Form
                  className="email-sign"
                  autoComplete="off"
                  onSubmit={this.login}>
                  <div className="phone-group">
                    <div className="plus">+</div>
                    <Form.Input
                      feedback="Invalid feedback"
                      placeholder={i18n.t('dash-login-areacode')}
                      value={this.state.areacode}
                      onChange={e =>
                        this.setState({ areacode: e.target.value })
                      }
                      className="area"
                    />
                    <Form.Input
                      feedback="Invalid feedback"
                      placeholder={i18n.t('dash-login-phone')}
                      onChange={e => this.setState({ phone: e.target.value })}
                      className="number"
                    />
                  </div>
                  <Form.Input
                    type="password"
                    value={this.state.password}
                    placeholder={i18n.t('dash-login-password')}
                    onChange={e => this.setState({ password: e.target.value })}
                  />
                  <Button
                    loading={this.state.isProcessing}
                    onClick={this.login}
                    color="primary">
                    {i18n.t('dash-login-submit')}
                  </Button>
                </Form>
              ) : (
                <Form
                  className="email-sign"
                  autoComplete="off"
                  onSubmit={this.login}>
                  <Form.Input
                    value={this.state.email}
                    feedback="Invalid feedback"
                    placeholder={i18n.t('dash-login-email')}
                    onChange={e => this.setState({ email: e.target.value })}
                  />
                  <Form.Input
                    type="password"
                    value={this.state.password}
                    placeholder={i18n.t('dash-login-password')}
                    onChange={e => this.setState({ password: e.target.value })}
                  />
                  <Button
                    loading={this.state.isProcessing}
                    onClick={this.login}
                    color="primary">
                    {i18n.t('dash-login-submit')}
                  </Button>
                </Form>
              )}

              <div className="form-bottom">
                <a
                  href="/signup?utm_source=dashboard&utm_medium=signin"
                  target="_self">
                  {i18n.t('dash-login-signup')}
                </a>
                <a href="/dashboard/forgot">{i18n.t('dash-login-forgot')}</a>
              </div>
              <div className="social-login">{i18n.t('dash-login-provider')}</div>
              <div className="social-btn-group">
                <div className={ `btn-social ${this.state.isWechat ? 'hide' : ''}`} onClick={() => window.gclient.requestAccessToken()}>
                  <img src={googleIcon} alt="wechat" />
                  <span>Google</span>
                </div>
                <div className={`btn-social ${this.state.isWechat ? 'hide' : ''}`} onClick={this.getUUID}>
                  <img src={wechat} alt="wechat" />
                  <span>{i18n.t('dash-login-wechat')}</span>
                </div>
              </div>
              <div
                className={`wechat-login ${this.state.wechatModal ? '' : 'hidden'
                  }`}>
                <Card className="content">
                  <Card.Header>
                    <Card.Title>
                      <img src={wechat} alt="wechat" />
                      {i18n.t('dash-login-wechattip')}
                    </Card.Title>
                    <div
                      className="closed"
                      onClick={() =>
                        this.setState({ wechatModal: false, wechatMessage: '' })
                      }>
                      <Icon name="x" />
                    </div>
                  </Card.Header>
                  <Card.Body>
                    {/* <div className="qrcode">
                      <img src={this.state.qrcodeBase64} alt="" />
                    </div> */}
                    <div className="wechat-message" style={{ color: 'red', padding: '50px' }}>
                      {this.state.wechatMessage ||'由于微信登录服务异常，暂停该功能，如果只绑定了微信，请联系客服提供支付凭证或者账号信息绑定邮箱。'}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </Card.Body>
          </Card>
        )}
      </Page>
    )
  }
}

export default Login
